import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { PromptGroup } from 'types/candidateStories';
import {
  findItemTranslation,
  getPromptItemById,
} from '../../../../../../../helpers';
import '../../../../../../../styles.scss';

const PromptSummaryItem = ({
  promptItemId,
  response,
  promptGroups,
  recordId,
}: {
  promptItemId: string;
  response: string;
  promptGroups: PromptGroup[];
  recordId?: string;
}) => {
  const currentLanguage = i18n.getLocale();
  const promptItem = getPromptItemById(promptGroups, promptItemId);

  const translatedItem = findItemTranslation(promptItem, currentLanguage);

  const testId = recordId
    ? `candidate-story-prompt-summary-item-${recordId}-${promptItemId}`
    : `candidate-story-prompt-summary-item-${promptItemId}`;

  return (
    <div className='prompt-summary-item' data-testid={testId}>
      <h6 className='prompt-summary-title'>{translatedItem?.title}</h6>
      <div className='prompt-summary-content'>{response}</div>
    </div>
  );
};

export default PromptSummaryItem;
